<template>
  <span
    class="material-symbols-outlined box-content inline-block shrink-0 overflow-hidden select-none"
    :class="[fontSize, width]"
    :style="{ fontVariationSettings: fontVariation }"
  >
    <slot />
  </span>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import type { IconSize } from './icon-props'

  interface Props {
    filled?: boolean
    size?: IconSize
  }

  const { size = '24', filled } = defineProps<Props>()

  const fontSize = computed(() => {
    if (size == '10') {
      return 'text-[10px]!'
    }
    if (size == '12') {
      return 'text-[12px]!'
    }
    if (size == '14') {
      return 'text-[14px]!'
    }
    if (size == '16') {
      return 'text-[14px]!'
    }
    if (size == '18') {
      return 'text-[18px]!'
    }
    if (size == '20') {
      return 'text-[20px]!'
    }
    if (size == '22') {
      return 'text-[22px]!'
    }
    if (size == '26') {
      return 'text-[26px]!'
    }
    if (size == '32') {
      return 'text-[32px]!'
    }
    if (size == '36') {
      return 'text-[36px]!'
    }
    if (size == '38') {
      return 'text-[38px]!'
    }
    if (size == '40') {
      return 'text-[40px]!'
    }
    if (size == '48') {
      return 'text-[48px]!'
    }
    if (size == '50') {
      return 'text-[50px]!'
    }
    return 'text-[24px]!'
  })
  const width = computed(() => {
    if (size == '10') {
      return 'w-[10px]!'
    }
    if (size == '12') {
      return 'w-[12px]!'
    }
    if (size == '14') {
      return 'w-[14px]!'
    }
    if (size == '16') {
      return 'w-[14px]!'
    }
    if (size == '18') {
      return 'w-[18px]!'
    }
    if (size == '20') {
      return 'w-[20px]!'
    }
    if (size == '22') {
      return 'w-[22px]!'
    }
    if (size == '26') {
      return 'w-[26px]!'
    }
    if (size == '32') {
      return 'w-[32px]!'
    }
    if (size == '36') {
      return 'w-[36px]!'
    }
    if (size == '38') {
      return 'w-[38px]!'
    }
    if (size == '40') {
      return 'w-[40px]!'
    }
    if (size == '48') {
      return 'w-[48px]!'
    }
    if (size == '50') {
      return 'w-[50px]!'
    }
    return 'w-[24px]!'
  })

  const fontVariation = computed(() => {
    const wght = "'wght' 400"
    const grad = "'GRAD' 0"
    const fill = filled ? "'FILL' 1" : "'FILL' 0"
    const opsz =
      "'opsz' " + (size == '18' || size == '16' || size == '14' || size == '10' ? '20' : size)

    return [wght, grad, fill, opsz].join(',')
  })
</script>
